import { takeLatest, call, put } from "redux-saga/effects";
import { apiUrl } from "../components/Config/config";
import { GET_DEAL_REDEEM } from "../actions";
import cookie from "react-cookies";
import Axios from "axios";

export const watchGetDealRedeem = function*(Param) {
  yield takeLatest(GET_DEAL_REDEEM, workerGetDealRedeem);
};

function* workerGetDealRedeem(Param) {
  const result = yield call(getDealRedeem, Param);
  yield put({
    type: "SET_DEAL_REDEEM",
    json: result.data || [{ error: result.message }]
  });
}

function getDealRedeem(Param) {
  var qs = require("qs");
  const options = {
    headers: { Auth: cookie.load("user_details").token }
  };
  return Axios.post(
    apiUrl + "redeem/redeem_deals",
    qs.stringify(Param.params),
    options
  ).then(
    response => {
      return response;
    },
    error => {
      return { data: { status: error.response.data.status } };
    }
  );
}
